import { React, useState } from "react";
import WhiteJMJLogo from "./WhiteJMJLogo";
import JMJButton from "./JMJButton";
import { useAuth } from "../AuthContext";

const Navbar = ({ language, includeLogout, isStaff, selectedTab, setSelectedTab }) => {
  const { logout } = useAuth();

  return (
    <div className="w-full bg-JMJ text-white font-bold">
      {/* Top bar */}
      <div className="flex flex-wrap sm:flex-nowrap items-center justify-between px-4 py-3">
        <div className="flex items-center justify-between w-full sm:w-auto">
          <div className="flex items-center gap-x-4">
            <WhiteJMJLogo />
          </div>
        </div>

        {/* Navigation Buttons */}
        <div className={`w-full flex flex-row justify-center md:justify-end md:mr-8 gap-2`}>
          {isStaff && isStaff === true && (
            <>
              <JMJButton className="mx-1" color="gray" onClick={() => setSelectedTab("Calendar")} text={"Calendar"} />
              <JMJButton className="mx-1"  color="gray" onClick={() => setSelectedTab("Users")} text={"Users"} />
            </>
          )}
          {includeLogout === true && (
            <JMJButton
              className="mx-1"
              onClick={logout}
              color="gray"
              text={language === "English" ? "Log Out" : "Cerrar sesión"}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
